import React, { useEffect } from "react";
import HeroSection from "../components/landingPage/HeroSection";
import LandingFeatureBox from "../components/landingPage/LandingFeatureBox";
import WorkFlowBox from "../components/landingPage/WorkFlowBox";
import Footer from "../components/landingPage/Footer";
import LandingPageNavbar from "../components/LandingPageNavbar";

const HomePage = () => {

  
  return (
    <div>
      <LandingPageNavbar />
      <HeroSection />
      <LandingFeatureBox />
      <WorkFlowBox />
      <Footer />
    </div>
  );
};

export default HomePage;
